import service, { AxiosRequestConfig, RequestConfig } from './axios';
export * from './types';

export const request = <T = any>(config: RequestConfig): Promise<T> => {
  console.log(config.url, 556);
  return new Promise((resolve, reject) => {
    service
      .request(config)
      .then((res) => {
        // 一些业务处理
        if (sessionStorage.getItem('backRes')) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          resolve(res);
        } else {
          resolve(res.data);
        }
      })
      .catch((err) => {
        // console.log('request fail:', err, config);
        reject(err);
      });
  });
};

const http = {
  get<T = any>(
    url: string,
    params?: object | null | undefined,
    config?: RequestConfig
  ): Promise<T> {
    return request({ url, params, ...config, method: 'GET' });
  },
  post<T = any>(url: string, data?: object | null | undefined, config?: RequestConfig): Promise<T> {
    return request({
      url,
      data,
      ...config,
      method: 'POST',
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    });
  },
  postForm<T = any>(
    url: string,
    data?: object | null | undefined,
    config?: RequestConfig
  ): Promise<T> {
    return request({
      url,
      data,
      ...config,
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
    });
  },
  // 上传文件，指定 'Content-Type': 'multipart/form-data'
  upload<T = any>(
    url: string,
    data?: object | null | undefined,
    config?: RequestConfig
  ): Promise<T> {
    return request(
      Object.assign(
        {
          url,
          data,
          method: 'POST',
          headers: { 'Content-Type': 'multipart/form-data' },
        },
        Object.assign({ disabledEnc: true }, { config })
      )
    );
  },
};

export default http;
